import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  updateAdditionalInfo(event) {
    const selectedValue = event.target.value;
    const additionalInfo = document.getElementById('additional-info');

    if (selectedValue === 'someone_else') {
      additionalInfo.style.display = 'block'; // Show additional info
    } else {
      additionalInfo.style.display = 'none'; // Hide additional info
    }
  }

  connect (){ 
    console.log("multistep controller connected")

    document.addEventListener("turbo:load", () => {
      const steps = document.querySelectorAll("[id^='step-']");
      let currentStep = 0;

      function showStep(step) {
        steps.forEach((s, index) => {
          s.style.display = index === step ? "block" : "none";
        });
      }


      //FIXME: not working, In refresh the information are not displayed
      function updateAdditionalInfoDisplay() {

      const checkedRadio = document.querySelector('input[name="appointment_for"]:checked');
      const selectedValue = checkedRadio ? checkedRadio.value : null;

        if (selectedValue) {
          // Proceed with your logic using selectedValue
          console.log("One radio button is selected.");

        } else {
          console.log("No radio button is selected.");
        }

        //const selectedValue = document.querySelector('input[name="appointment_for"]:checked').value;
        const additionalInfo = document.getElementById('additional-info');
        if (additionalInfo) {
          if (selectedValue === 'someone_else') {
            additionalInfo.style.display = 'block'; // Show additional info
          } else {
            additionalInfo.style.display = 'none'; // Hide additional info
          }
        }
      }

      // Initial check on page load
      updateAdditionalInfoDisplay();

      showStep(currentStep);

      // Handle radio button change
      document.querySelectorAll('.appointment-for').forEach(radio => {
        radio.addEventListener('change', (event) => {
          const additionalInfo = document.getElementById('additional-info');
          if (event.target.value === 'someone_else') {
            additionalInfo.style.display = 'block'; // Show additional info
          } else {
            additionalInfo.style.display = 'none'; // Hide additional info
          }
        });
      });

      document.querySelectorAll("[data-action]").forEach(button => {
        button.addEventListener("click", (event) => {
          if (event.target.innerText.includes("Next")) {
            currentStep++;
          } else if (event.target.innerText.includes("Back")) {
            currentStep--;
          }
          showStep(currentStep);
        });
      });
    });

  }
}